<template>

  <v-menu
    offset-y
    left
    :close-on-content-click = "false"
  >

    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind    = "attrs"
        v-on      = "on"
      >
        <v-icon>mdi-tab</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <v-list-item-group
        multiple
        :value  = "value"
        @change = "onSetActiveTabs"
      >

        <v-list-item 
          v-for     = "(tab, index) in filteredTabs"
          color     = "primary"
          :key      = "index"
          :value    = "tab"
          :disabled = "toExclude.includes(tab)"
        >
          <template v-slot:default="{ active }">
            <v-list-item-action>
              <v-checkbox 
                :input-value  = "active"
                :disabled     = "toExclude.includes(tab)"
              >
              </v-checkbox>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{ tab }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-list-item>

      </v-list-item-group>

      <v-divider></v-divider>

      <v-list-item @click="onReset">
        <v-list-item-icon><v-icon>mdi-undo</v-icon></v-list-item-icon>
        <v-list-item-title class="text--secondary">Reset to Default</v-list-item-title>
      </v-list-item>
    </v-list>

  </v-menu>

</template>

<script>

export default {

  // #region Properties

  name: 'TabsMenu',
  data() {
    return {
      tabs: [
        'Audio',
        'Clips',
        'Frame',
        'Inspector',
        'Plugins',
        'Scopes',
        'Annotations'
      ]
    };
  },
  props: {
    value:   Array,
    exclude: Array,
    hidden:  Array
  },
  computed: {
    toExclude() {
      return this.exclude || [];
    },
    filteredTabs() {
      return this.tabs.filter(t => this.hidden ? !this.hidden.includes(t) : true);
    }
  },

  // #endregion Properties

  // #region Methods

  methods: {

    // #region Events

    onSetActiveTabs(tabs) {
      this.$emit('input', tabs);
    },

    onReset() {
      this.$emit('reset');
    }

    // #endregion Events

  }

  // #endregion Methods

}

</script>
